module.exports = __webpack_public_path__ + "img/item_reunion.6f415449.png";